export { default } from "./status";
export { type IStatusProps, StatusType } from "./status.types";
